var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotParticipateTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials/timer/off Duotone"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Icon",
    cx: 12,
    cy: 14,
    r: 9,
    fill: "#E5E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M20.3541 10.6458C21.6546 13.8893 20.9912 17.7367 18.364 20.364C15.7367 22.9913 11.8892 23.6546 8.64577 22.3541M21 3.9999L17.8445 7.15537M17.8445 7.15537C14.3085 4.12942 8.98246 4.28965 5.63604 7.63608C2.28962 10.9825 2.12938 16.3086 5.15533 19.8446M17.8445 7.15537L5.15533 19.8446M5.15533 19.8446L3 21.9999M12 5V2M9.99996 2H14M12 10V13",
    stroke: "#8278F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotParticipateTab);
export default __webpack_public_path__ + "static/media/not-participate_tab.dd3a27ec7b98b5e6d1e077e7e27e1758.svg";
export { ForwardRef as ReactComponent };